import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "../rootReducer";

const getState = (state: AppState) => state.config;

export const remoteConfigsSelector = createSelector(
  [getState],
  (config) => config.remoteConfigs
);
